import { PENALTY_KINDS } from "constants/agreement/penaltyKinds";

const judgementsParser = judgements => {
  const newArrayJudgements = [];

  if (judgements?.length > 0) {
    judgements.forEach(item => {
      const parcels = item.installments ? item.installments.map(inst => ({
        date: inst.finalDate || inst.initialDate
      })) : item.parcels || [];

      const lastParcel = parcels.length > 0 ? 
                         [...parcels].sort((a, b) => new Date(b.date) - new Date(a.date))[0] : null;
      const lastDate = lastParcel?.date || item.paymentDeadline;
      
      const newJudgement = {
        ...item,
        description: item.description,
        firstAttendanceDate: item.firstAttendanceDate,
        paymentDeadline: lastDate,
        penalty: PENALTY_KINDS.ATTENDANCE_OF_JUDGEMENT,
        attendanceQuantity: item.installments?.length || item.parcels?.length || item.numbersOfParcel || 0,
        parcels: parcels
      };

      newArrayJudgements.push(newJudgement);
    });
  }

  return newArrayJudgements;
};

export default judgementsParser;
